export default "__VITE_ASSET__WoOnsqOY__"